import importerStore from '@shared/importer/importer-store';
import { NewsService } from '@modules/news/news-service';
import newsImporterFields from '@modules/news/news-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  NewsService.import,
  newsImporterFields,
  i18n('entities.news.importer.fileName'),
  i18n('entities.news.importer.hint'),
);
